/* Başlık, fiyat ve özellikler fotoğrafla aynı bakış alanında okunur. */
[data-ilan-detay-alani] {
  padding: 12px 32px 32px !important;
  gap: 18px !important;
}
[data-ilan-ust-yerlesimi] {
  display: grid !important;
  grid-template-columns: minmax(0, 1.6fr) minmax(270px, 1fr) 232px;
  grid-template-areas: 'galeri fiyat bilgiler' 'galeri ozellikler bilgiler';
  grid-template-rows: auto minmax(0, 1fr);
  column-gap: 20px !important;
  row-gap: 8px !important;
  align-items: start !important;
}
[data-ilan-web-baslik] {
  min-width: 0;
}
[data-ilan-galeri-alani] {
  grid-area: galeri;
  min-width: 0;
}
[data-ilan-yan-alani] {
  grid-area: bilgiler;
  min-width: 0;
  gap: 12px !important;
}
[data-ilan-ozellik-alani] {
  grid-area: ozellikler;
  min-width: 0;
}
[data-ilan-masaustu-eylemi] {
  flex-direction: column !important;
}
[data-ilan-baslik] {
  gap: 4px !important;
}
[data-ilan-baslik] [aria-level='1'] {
  font-size: 24px !important;
  line-height: 32px !important;
}
[data-ilan-fiyat-alani] {
  grid-area: fiyat;
  gap: 4px !important;
}
[data-ilan-ana-fiyati] {
  font-size: 25px !important;
  line-height: 33px !important;
}
[data-ilan-satici-karti] {
  padding: 14px !important;
  gap: 10px !important;
}
[data-ilan-ust-eylemleri] {
  gap: 12px !important;
}
[data-ilan-mobil-eylemi],
[data-ilan-eylemleri] {
  display: none !important;
}
[data-ilan-ozellik-adi] {
  width: 45% !important;
  min-width: 0;
  overflow-wrap: anywhere;
}
[data-ilan-ozellik-satiri] > div:last-child {
  overflow-wrap: anywhere;
}
[data-ilan-detay-alani] [role='tabpanel'] {
  scroll-margin-top: 110px;
}
@media (min-width: 700px) {
  [data-ilan-galeri-alani] .ilan-galeri-ana {
    height: clamp(300px, 46svh, 450px);
  }
  [data-ilan-ozellik-satiri] {
    align-items: center;
    min-height: 29px;
    gap: 10px !important;
    padding: 4px 0 !important;
    background: transparent !important;
    border-radius: 0 !important;
    border-bottom: 1px dotted var(--renk-cizgi);
  }
  [data-ilan-ozellik-adi] {
    color: var(--renk-murekkep) !important;
    font-weight: 600 !important;
  }
  [aria-label='İlan numarasını kopyala'] {
    width: 28px !important;
    min-width: 28px !important;
    height: 28px !important;
    min-height: 28px !important;
  }
}
@media (min-width: 700px) and (max-width: 1099px),
  (min-width: 700px) and (max-width: 1439px) and (pointer: coarse) {
  [data-ilan-detay-alani] {
    padding-inline: 24px !important;
  }
  [data-ilan-ust-yerlesimi] {
    grid-template-columns: minmax(0, 1.25fr) minmax(250px, 1fr);
    grid-template-areas: 'galeri fiyat' 'galeri ozellikler' 'bilgiler bilgiler';
    grid-template-rows: auto minmax(0, 1fr) auto;
  }
  [data-ilan-yan-alani] {
    display: grid !important;
    grid-template-columns: minmax(0, 1.25fr) minmax(250px, 1fr);
    grid-template-areas: 'satici iletisim' 'satici sikayet';
    grid-template-rows: auto 1fr;
    column-gap: 20px !important;
    row-gap: 8px !important;
    width: 100%;
    margin-top: 8px;
  }
  [data-ilan-satici-karti] {
    grid-area: satici;
  }
  [data-ilan-iletisim-eylemleri],
  [data-ilan-masaustu-eylemi] {
    grid-area: iletisim;
  }
  [data-ilan-sikayet-alani] {
    grid-area: sikayet;
  }
  [data-ilan-masaustu-eylemi] {
    flex-direction: row !important;
  }
  [data-ilan-galeri-alani] .ilan-galeri-ana {
    height: clamp(320px, 42svh, 460px);
  }
  [data-ilan-detay-alani] [role='tabpanel'] {
    scroll-margin-top: 175px;
  }
  [aria-label='İlan numarasını kopyala'] {
    width: 40px !important;
    min-width: 40px !important;
    height: 40px !important;
    min-height: 40px !important;
  }
}
@media (max-width: 699px) {
  [data-ilan-detay-alani] {
    padding: 8px 20px 100px !important;
    gap: 16px !important;
  }
  [data-ilan-ust-yerlesimi] {
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: 'fiyat' 'galeri' 'bilgiler';
    grid-template-rows: none;
    gap: 16px !important;
  }
  [data-ilan-ozellik-alani] {
    display: none !important;
  }
  [data-ilan-baslik] [aria-level='1'] {
    font-size: 21px !important;
    line-height: 28px !important;
  }
  [data-ilan-ana-fiyati] {
    font-size: 26px !important;
    line-height: 34px !important;
  }
  [data-ilan-ust-eylemleri] {
    gap: 10px !important;
  }
  [data-ilan-masaustu-eylemi] {
    display: none !important;
  }
  [data-ilan-mobil-eylemi],
  [data-ilan-eylemleri] {
    display: flex !important;
  }
  [data-ilan-eylemleri] {
    padding-inline: 20px !important;
  }
  [data-ilan-eylemleri] > [dir] {
    font-size: 21px !important;
    line-height: 29px !important;
  }
  [data-ilan-eylemleri] > [role='button'] {
    padding-inline: 18px !important;
  }
  [data-ilan-ozellik-satiri] {
    gap: 12px !important;
    padding-inline: 10px !important;
  }
  [data-ilan-ozellik-adi] {
    width: 42% !important;
  }
  [data-ilan-benzerleri] [data-ilan-hucresi]:nth-child(n + 5) {
    display: none !important;
  }
  [data-ilan-benzerleri] [aria-level='2'] {
    font-size: 21px !important;
  }
  [data-ilan-detay-alani] [role='tabpanel'] {
    scroll-margin-top: 155px;
  }
}
@media (max-width: 359px) {
  [data-ilan-eylemleri] > [dir] {
    font-size: 18px !important;
  }
  [data-ilan-eylemleri] > [role='button'] {
    padding-inline: 12px !important;
  }
}
html.pazar-klavye-acik [data-ilan-eylemleri] {
  display: none !important;
}
